import { Link } from 'react-router-dom';
import { articles, hotRankings } from '@/mocks/data';

const rankingImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20visual%20with%20bold%20red%20headline%20typography%20on%20warm%20dark%20background%20celebrity%20spotlight%20effect%20modern%20editorial%20magazine%20cover%20style%20high%20contrast%20no%20skulls&width=400&height=300&seq=rank-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Romantic%20night%20street%20scene%20with%20warm%20golden%20streetlights%20blurred%20figures%20walking%20paparazzi%20style%20soft%20bokeh%20entertainment%20news%20atmosphere%20elegant%20mood&width=400&height=240&seq=rank-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20on%20glossy%20desk%20under%20studio%20lighting%20luxury%20beauty%20skincare%20flat%20lay%20editorial%20photography%20clean%20composition%20warm%20neutral%20tones%20high%20detail&width=400&height=240&seq=rank-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Colorful%20trophy%20and%20medal%20ranking%20visual%20bright%20festive%20atmosphere%20celebration%20confetti%20golden%20warm%20lighting%20editorial%20design%20concept%20vibrant%20red%20and%20gold%20accents&width=400&height=240&seq=rank-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=TV%20studio%20spotlights%20and%20stage%20lights%20dramatic%20entertainment%20set%20warm%20color%20temperature%20reality%20show%20atmosphere%20professional%20broadcast%20equipment%20cinematic%20lighting&width=400&height=240&seq=rank-05&orientation=landscape',
};

export default function HeroSection() {
  const headlineArticle = articles.find(a => a.isHot && a.isExclusive) || articles[0];

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20red%20and%20black%20abstract%20gradient%20background%20with%20subtle%20texture%20modern%20editorial%20design%20atmosphere%20bold%20mysterious%20mood%20cinematic%20lighting%20with%20warm%20accents%20dark%20vignette&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-1 h-10 bg-primary-500 rounded-full"></div>
              <span className="tag-pill bg-primary-500/20 text-primary-400 font-label">
                今日头条
              </span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] mb-4">
              {headlineArticle.title}
            </h1>
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 font-label max-w-lg">
              {headlineArticle.excerpt.length > 120 ? headlineArticle.excerpt.slice(0, 120) + '...' : headlineArticle.excerpt}
            </p>
            <div className="flex items-center gap-4">
              <Link
                to={`/article/${headlineArticle.slug}`}
                className="btn-primary flex items-center gap-2"
              >
                查看详情
                <span className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
              <span className="text-white/50 text-xs font-label">
                {headlineArticle.heat.toLocaleString()} 热度
              </span>
            </div>
          </div>

          <div className="lg:col-span-4 flex items-center">
            <Link to={`/article/${headlineArticle.slug}`} className="block w-full rounded-2xl overflow-hidden group relative">
              <div className="aspect-[4/3] overflow-hidden rounded-2xl">
                <img
                  src={headlineArticle.imageUrl}
                  alt={headlineArticle.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute top-4 left-4">
                <span className="tag-pill bg-primary-500 text-white font-label">爆</span>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/10">
              <div className="flex items-center justify-between mb-5">
                <h2 className="font-heading text-lg font-bold text-white">实时热瓜榜</h2>
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-primary-400 text-sm"></i>
                </span>
              </div>

              <div className="flex flex-col gap-4">
                {hotRankings.map((item, index) => {
                  const imageUrl = rankingImages[item.rank];
                  const isLarge = index === 0;
                  return (
                    <Link
                      key={item.rank}
                      to={`/article/${item.slug}`}
                      className={`group relative rounded-xl overflow-hidden ${
                        isLarge ? 'aspect-[4/3]' : index <= 2 ? 'aspect-[3/2]' : 'hidden md:block md:aspect-[3/2]'
                      }`}
                    >
                      <img
                        src={imageUrl}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-3">
                        <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-full font-label mb-1">
                          TOP {item.rank}
                        </span>
                        <p className="text-white text-xs font-label line-clamp-2 leading-snug">{item.title}</p>
                      </div>
                    </Link>
                  );
                })}
              </div>

              <Link
                to="/category/zuixin-baoliao"
                className="mt-4 flex items-center justify-center gap-1 text-primary-400 text-xs font-label hover:text-primary-300 transition-colors"
              >
                查看完整榜单
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}